import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Building2, Map, Heart, Shield, TrendingUp, Users } from 'lucide-react';
export function Issues() {
  const issues = [{
    title: 'Local Control',
    description: 'Protecting the authority of Arizona cities and towns to make decisions for their own communities.',
    icon: Building2
  }, {
    title: 'Land Use & Zoning',
    description: 'Preserving local authority over land use, zoning, and thoughtful community planning.',
    icon: Map
  }, {
    title: 'Quality of Life',
    description: 'Advancing policies that help every Arizona community remain a great place to live and raise a family.',
    icon: Heart
  }, {
    title: 'Public Safety',
    description: 'Supporting local leaders with the flexibility and resources to keep neighborhoods safe.',
    icon: Shield
  }, {
    title: 'Economic Growth',
    description: 'Fostering responsible economic development, local opportunity, and resilient municipal economies.',
    icon: TrendingUp
  }, {
    title: 'Bipartisan Partnership',
    description: 'Bringing municipal leaders, businesses, and advocates together around practical Arizona solutions.',
    icon: Users
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="issues" className="py-24 bg-white" data-id="element-122" data-mp="2iik402qvk8wd">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123" data-mp="2igz6c499k9ua">
        <div className="text-center mb-16" data-id="element-124" data-mp="367lb9mnz1e02">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-4" data-id="element-125" data-mp="366tg2cyadiab">
            Issues We Champion
          </h2>
          <div className="w-24 h-1 bg-pac-red mx-auto" data-id="element-126" data-mp="3kvv3d8kz901o" />
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-127" data-mp="3fw8u1a89s3y5">
          {issues.map(issue => <motion.article key={issue.title} variants={itemVariants} className="bg-slate-50 p-8 rounded-xl border border-slate-200" data-id="element-128" data-mp="31wqz0d4drugc">
              <div className="w-14 h-14 bg-white rounded-lg shadow-sm flex items-center justify-center mb-6" data-id="element-129" data-mp="2s6634xg3d414">
                <issue.icon className="h-7 w-7 text-pac-blue" data-id="element-130" data-mp="2o5vo6vabn3a4" />
              </div>
              <h3 className="font-serif text-2xl font-bold text-pac-navy mb-3" data-id="element-131" data-mp="2j5q0fq76a0xb">
                {issue.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-132" data-mp="2e7y3ghro7om9">
                {issue.description}
              </p>
            </motion.article>)}
        </motion.div>
      </div>
    </section>;
}